module.exports = __webpack_public_path__ + "static/sport/form-bg-1.4f01a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/form/form-bg-1.png
// module id = S2ok
// module chunks = 0